import { CdkStepper } from '@angular/cdk/stepper';
import { AfterViewInit, Component, Input, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { DhlFormControlEventData } from '../../dhl-form/models/dhl-form-control-event-data';

@Component({
    selector: 'app-horizontal-stepper-v2',
    templateUrl: './horizontal-stepper-v2.component.html',
    styleUrls: ['./horizontal-stepper-v2.component.scss'],
    providers: [{ provide: CdkStepper, useExisting: HorizontalStepperV2Component }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HorizontalStepperV2Component implements OnInit, AfterViewInit, OnDestroy {

  constructor(private appService: AppService,private cd: ChangeDetectorRef) { }

  @Input() configData;
  @Input() navIn;
  subscription: Subscription;
  navInSubscription: Subscription;

  steps_titles;
  widthcss;
  isStepperLocked = true;
  ngOnInit() {
    setTimeout(() => {
      this.isStepperLocked = false;
       this.cd.detectChanges();
    }, 2000);
    // console.log(this.configData);
    this.steps_titles = this.configData.labels;
    let len = this.steps_titles.length;
    let divisions = 0;
    if (this.steps_titles.length > 0) {
      divisions = Math.ceil(100 / len);
      this.widthcss = {
        width: divisions + '%'
      };
    }
  }

  ngAfterViewInit(){
    // this.steps_titles.forEach(element => {
    //   if(element.show){
    //     let elem = document.getElementById(element.name);
    //     if(elem){
    //       elem.style.transform = 'none';
    //       elem.style.visibility = 'visible';
    //       elem.style.height = '100%';
    //     }
    //   }
    // });

    this.subscription = this.appService._stepIndexSub.subscribe(res=>{
      if(res){
        this.steps_titles = res['stepper'];
        this.selectedIndex = res['index'];
      }
    })
    this.navInSubscription = this.navIn.subscribe(navName=>{      
      if(navName == 'prev' && this.selectedIndex !== 0){
        this.onClick(this.steps_titles[this.selectedIndex - 1], this.selectedIndex - 1);
      }else if(navName == 'next' && this.selectedIndex < this.configData.labels.length - 1){
        this.onClick(this.steps_titles[this.selectedIndex + 1], this.selectedIndex + 1);
      }
    });

    this.appService._formErrorCheck.subscribe( res =>{
      let stepIndex=(this.steps_titles.length - 1)
      let step ={
				"valid": this.steps_titles[stepIndex]["valid"],
				"multipleFormCheck": this.steps_titles[stepIndex]["multipleFormCheck"],
				"validateForm": this.steps_titles[stepIndex]['name'],
				"name": this.steps_titles[stepIndex]["name"],
				"show": this.steps_titles[stepIndex]["show"],
				"title": this.steps_titles[stepIndex]["title"]
			}
      this.onClick(step,stepIndex)
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
    this.navInSubscription.unsubscribe();
    this.appService.updateEnableFinalStepAction(false);
  }

  submitted = false;
  selectedIndex = 0;

  onClick(step, index: number) {  
    if (this.isStepperLocked  && (index === 3 || index === 4)) {
      return;
    }
    let  data = JSON.parse(sessionStorage.getItem("isSelfServiceConfig"));
   if(data == true){
     Object.keys(step).forEach((item) => {
          if( item == "validateForm" ) {
            step[item] = ""
          }
      })
    }

   else {
    if(step.events){
       //START: Removed hard coded 'STEPPER_INIT' to handle Unapproved fees, Sprint-29-CP-2801
       this.appService._commonComponentSubject.next({name: step.name, action:step.events[0].event, event: step.events[0]});
       //END
    }
   }
   this.appService._stepperContentSubject.next({'stepperForm':step, 'stepperDetails': this.steps_titles, 'stepIndex': index});
    if(document.getElementById(step.name).style.visibility === 'visible'){
      this.selectedIndex = index;            
    // next({'stepperForm':step, 'stepperDetails': this.steps_titles});
    // scroll to top after stepper navigation
    document.getElementsByTagName('main')[0].scrollIntoView({behavior: "smooth"});
    }
    if(step?.enableFinalStepAction && this.selectedIndex == this.steps_titles.length - 1) {
      this.appService.updateEnableFinalStepAction(true);
    }
  }
  
  submit(m: boolean) {
    this.steps_titles[this.selectedIndex].message = m;
    if (m == true) {
      if (this.selectedIndex < this.steps_titles)
        this.selectedIndex = this.selectedIndex + 1;

    }
  }

}
